import {
  IGroupInfoMembers,
  IUserId,
  IVisibleTo,
} from "@home-health-notify/domain";
import { ListItemAvatar, ListItemText } from "@mui/material";
import UserImage from "../../../common/user/UserImage";
import { UserTitle } from "../../../common/user/UserText";
import { AVATAR_SIZE } from "../../../utils/AvatarUtils";
import {
  MessageItemModalListItem,
  MessageItemModalListItemContent,
  MessageItemModalListItemStyle,
  MessageItemModalListWrapper,
  StyledCheckbox,
} from "../MessagePanel.style";
import RecipientMessageStatus from "./RecipientMessageStatus";

type RecipientListProps = {
  recipients: IVisibleTo[] | IGroupInfoMembers[];
  selectedUsers?: IUserId[];
  handleUserSelected?: (userId: IUserId) => void;
  showCheckbox?: boolean;
  dataTestId: string;
  showMessageStatus?: boolean;
};

const RecipientList = ({
  recipients,
  selectedUsers,
  handleUserSelected,
  showCheckbox = false,
  dataTestId,
  showMessageStatus,
}: RecipientListProps) => {
  const listToRender = recipients;
  return (
    recipients.length > 0 &&
    listToRender &&
    Array.isArray(listToRender) && (
      <MessageItemModalListWrapper data-testid={dataTestId}>
        {listToRender.map((item: any) => {
          const id = item.id ?? item.userId;
          return (
            <MessageItemModalListItem
              key={id}
              showCheckbox={showCheckbox}
              divider
              disableGutters
              secondaryAction={
                showCheckbox && (
                  <StyledCheckbox
                    edge="end"
                    checked={selectedUsers ? selectedUsers.includes(id) : false}
                    onChange={() =>
                      handleUserSelected && handleUserSelected(id)
                    }
                  />
                )
              }
            >
              <MessageItemModalListItemStyle
                disableRipple
                disableTouchRipple
                showCheckbox={showCheckbox}
                onClick={() => handleUserSelected && handleUserSelected(id)}
              >
                <MessageItemModalListItemContent>
                  <ListItemAvatar>
                    <UserImage userId={id} avatarSize={AVATAR_SIZE.LARGE} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={<UserTitle userId={id} />}
                    secondary={
                      showMessageStatus && (
                        <RecipientMessageStatus recipient={item} />
                      )
                    }
                  />
                </MessageItemModalListItemContent>
              </MessageItemModalListItemStyle>
            </MessageItemModalListItem>
          );
        })}
      </MessageItemModalListWrapper>
    )
  );
};

export default RecipientList;
